module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg11_bar.d743e942.jpg";